






































































import Vue from 'vue';
import key from '@/libs/filters/key';
import util from '@/utils';
import { Component, Prop } from 'vue-property-decorator';
@Component({
  components: {}
})
export default class Search extends Vue {
  @Prop({
    type: Function,
    default() {
      return function() {};
    }
  })
  handleOptions!: Function;

  @Prop({
    type: Function,
    default() {
      return function() {};
    }
  })
  getData!: Function;

  private key: any = key;
  private form: any = {
    orgName: '', // 校区名称
    activationCode: '', // 激活码
    activationStatus: '', // 激活码状态
    InvalidStartTime: '', // 失效日期始
    InvalidEndTime: '' // 失效日期止
  }
  private expiryDate: any = '' // 失效日期

  private search() {
    let f = this.form
    let opts = {
      orgName: f.orgName,
      activationCode: f.activationCode,
      activationStatus: f.activationStatus,
      InvalidStartTime: this.expiryDate[0],
      InvalidEndTime: this.expiryDate[1],
      currentPage: 1
    }
    this.handleOptions(opts)
    this.getData()
  }
  private reset() {
    this.form = {
      orgName: '',
      activationCode: '',
      activationStatus: '',
      InvalidStartTime: '',
      InvalidEndTime: ''
    }
    this.expiryDate = ''
    this.search()
  }
}
